import {createContext, useContext} from 'react';
import {createContextualCan} from "@casl/react";
import {store} from "../../redux/store/store";

// Todo
export const AbilityContext = createContext({});
export const useAbilityContext = () => useContext(AbilityContext)
export const Can = createContextualCan(AbilityContext.Consumer);

export const AbilityUtil = {
    allow: (action, subjectName, conditionObject = {}) => {
        const {ability} = store.getState()?.abilityReducer

        if (!ability) return false

        if (ability.can === undefined) return false;

        const cloneConditionObject = {...conditionObject}

        cloneConditionObject._subjectName = subjectName
        return ability?.can(action, cloneConditionObject || subjectName)
    }
}
export const AllowButton = ({action, subjectName, conditionObject = {}, children, not, passThrough}) => {

    const cloneConditionObject = {...conditionObject}

    cloneConditionObject._subjectName = subjectName

    return <Can do={action}
                on={cloneConditionObject || subjectName}
                not={not}
                passThrough={passThrough}
                children={children}
    >
        {children}
    </Can>
}